import * as React from 'react'
import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { ILocationSearchModel } from '@user/query/useLocationSearch'
import { ENTITY_TYPES } from '@sales-center/common'
import { ContactsPage } from '../ContactsPage/ContactsPage'
import useTheme from '@mui/material/styles/useTheme'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  canUpdateEntity: boolean
  initialTab?: number
  location?: ILocationSearchModel
  open: boolean
  onClose: () => void
  skipEnterAnimation?: boolean
}

export const ContactsDialog: React.FC<Props> = (props) => {
  const { open, onClose, skipEnterAnimation } = props

  const {
    transitions: { duration },
  } = useTheme()

  return (
    <FullScreenDialog
      open={open}
      onClose={onClose}
      closeButtonText="Close"
      transitionDuration={
        skipEnterAnimation
          ? { enter: 0, exit: duration.leavingScreen }
          : undefined
      }
    >
      <ContactsPage {...props} />
    </FullScreenDialog>
  )
}
ContactsDialog.displayName = 'ContactsDialog'
